"use client";

import { useRef, useState, useEffect } from "react";
import { Link } from "@/i18n/navigation";
import { motion, useReducedMotion } from "motion/react";
import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

// Icônes Solar, comme partout ailleurs sur la plateforme. Variante au trait :
// ce sont des filtres, pas des accents, et un seul élément doit ressortir, celui
// qui est actif.
const categories = [
    {
        id: "all",
        icon: null,
    },
    {
        id: "developers",
        icon: "programming-linear",
    },
    {
        id: "entrepreneurs",
        icon: "case-minimalistic-linear",
    },
    {
        id: "nocode",
        icon: "bolt-linear",
    },
];

export default function CoursesCategoryFilter({ category, level }) {
    const t = useTranslations();
    const reduceMotion = useReducedMotion();
    const scrollRef = useRef(null);
    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);

    const handleScroll = (e) => {
        const { scrollLeft, scrollWidth, clientWidth } = e.target;
        setIsAtStart(scrollLeft === 0);
        setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
    };

    useEffect(() => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            setIsAtStart(scrollLeft === 0);
            setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
        }
    }, []);

    return (
        <div
            className={`gradient-wrapper relative mt-4 ${
                isAtStart ? "hide-left" : ""
            } ${isAtEnd ? "hide-right" : ""}`}
        >
            <div
                ref={scrollRef}
                onScroll={handleScroll}
                className="flex gap-2 overflow-x-auto pb-2 relative"
                style={{ scrollbarWidth: "none" }}
            >
                {categories.map((cat) => {
                    const isActive = category === cat.id || (!category && cat.id === "all");

                    return (
                        // Même correction que dans CoursesTabs : le lien porte
                        // l'apparence, il n'enveloppe plus un bouton.
                        <Link
                            key={cat.id}
                            href={{
                                pathname: "/courses",
                                query: {
                                    level: level || "discover",
                                    ...(cat.id !== "all" && { category: cat.id }),
                                },
                            }}
                            // Changer de filtre ne doit pas faire bouger la page : on reste devant la liste.
                            scroll={false}
                            aria-current={isActive ? "page" : undefined}
                            className={`
                                relative flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm
                                transition-colors duration-200 whitespace-nowrap bg-gray-100 dark:bg-white/5
                                ${
                                    isActive
                                        ? "!text-white"
                                        : "text-gray-700 dark:text-grayDark-300 hover:bg-gray-200 dark:hover:bg-white/10"
                                }
                            `}
                        >
                            {/* La pastille active glisse d'un filtre à l'autre au lieu de sauter. */}
                            {isActive && (
                                <motion.span
                                    layoutId="courses-category"
                                    className="absolute inset-0 rounded-xl bg-primary shadow-md shadow-primary/25"
                                    transition={reduceMotion ? { duration: 0 } : { duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                                />
                            )}
                            {cat.icon && <SolarIcon name={cat.icon} className="relative w-4 h-4" />}
                            <span className="relative">{t(`courses_category_${cat.id}`)}</span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
